import Hotjar from "@hotjar/browser";
if (import.meta.env.PROD) Hotjar.init(3672479, 6);
